import { h } from 'preact';

import { slugify } from '../../../common/utils/string.utils';
import { useTranslation } from '../../../i18n';
import type { Membership } from '../../../membership/models/membership.model';
import type { ContentTab } from '../../model/tab.interface';
import { ContentType } from '../../model/tab.interface';
import { PerksNavLink } from './perks-nav-link';

interface Props {
  hasActiveFilters: boolean;
  onCloseNavOverflow: () => void;
  onTabClick: (tab: ContentTab) => void;
  memberships: Membership[];
  tabs: ContentTab[];
}

export const PerksNavLinks = ({
  hasActiveFilters,
  onCloseNavOverflow,
  onTabClick,
  memberships,
  tabs,
}: Props) => {
  const { t } = useTranslation();
  const navigationOptions = {
    queryParams: {},
  };
  const anyActiveMemberships =
    memberships?.length > 0 && memberships?.some((m) => m.state === 'PUBLISHED');
  const noMembershipsWithContract = memberships?.every((m) => !m.contractId);

  return (
    <>
      <PerksNavLink
        show={anyActiveMemberships && noMembershipsWithContract}
        link="/join"
        queryParams={navigationOptions?.queryParams}
        onClick={onCloseNavOverflow}
        id="single-join-tab"
        title={t('perks.join')}
      />

      {tabs.map((tab) => {
        const link =
          tab.contentType === ContentType.CUSTOM
            ? `/pages/${tab.id}`
            : `/${tab.contentType.toLowerCase()}`
                .replace('post', 'posts')
                .replace('video', 'videos')
                .replace('album', 'music')
                .replace('product', 'merch')
                .replace('promotion', 'codes');
        return (
          <PerksNavLink
            key={tab.id ?? tab.contentType}
            show={true}
            link={link}
            title={tab.name}
            id={
              tab.contentType === ContentType.CUSTOM
                ? `single-${tab.contentType.toLowerCase()}-tab-${slugify(tab.name)}`
                : `single-${tab.contentType.toLowerCase()}-tab`
            }
            onClick={() => {
              onCloseNavOverflow();
              onTabClick(tab);
            }}
          />
        );
      })}
    </>
  );
};
